export default __webpack_public_path__ + "static/media/blocked-user-icon.1d25c4b8.svg";